import { applyMiddleware, createStore } from 'redux';
/* eslint-disable-next-line import/no-extraneous-dependencies */
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  createStateSyncMiddleware,
  initMessageListener,
} from 'redux-state-sync';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';

import createRootReducer from './reducers';
import rootSaga from './sagas';
import { syncVoxEvents, VOX_EVENTS_CHANNEL } from '../consts/vox';
import { getAppBasePath } from '../modules/appMode';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({ basename: getAppBasePath() });

const sagaMiddleware = createSagaMiddleware({
  onError: (err, { sagaStack }) => {
    console.log('ERROR HAPPENED', err, sagaStack);
  },
});

const syncTabsMiddleware = createStateSyncMiddleware({
  channel: VOX_EVENTS_CHANNEL,
  predicate: syncVoxEvents,
  broadcastChannelOption: { type: 'localstorage' },
});

const store = createStore(
  createRootReducer({
    history,
  }),
  composeWithDevTools(
    applyMiddleware(
      sagaMiddleware,
      syncTabsMiddleware,
      routerMiddleware(history)
    )
  )
);

sagaMiddleware
  .run(rootSaga)
  .toPromise()
  .catch(e => {
    console.info({
      event: e,
      message: e.message,
      source: 'sagaError',
      stacktrace: e.sagaStack,
    });
  });

initMessageListener(store);

export default store;
